import React, { useEffect, useContext, useState } from "react";
import { POS } from "../utils";
import { LexiquePatterns } from "./State";
import ProjectPatternsFilter from "./PatternsFilter";
import LexiconTable from "./LexiconTable";
import { ProjectFilterContext } from "../ProjectFilterContext";

export default function ProjectPatterns(props: any) {
  const projectFilter = useContext(ProjectFilterContext);
  const [searchParams, setSearchParams] = useState({
    posPatterns: LexiquePatterns,
    term: "",
    minMaxOccurrence: [1, 10000] as [number, number],
    enableParsing: false,
    semanticSearch: false,
    projectFilter: projectFilter.conditions
  });

  useEffect(
    () => {
      setSearchParams(s => ({
        ...s, projectFilter: projectFilter.conditions
      }));
    }
  , [projectFilter.conditions]);

  return (
    <>
      <div className="relative overflow-x-auto">
        <ProjectPatternsFilter
          onSearch={(
            patterns: POS[][],
            minMaxOccurrence: [number, number],
            term: string,
            enableParsing: boolean
          ) => {
            setSearchParams({
              posPatterns: patterns,
              term,
              minMaxOccurrence,
              enableParsing,
              semanticSearch: false,
              projectFilter: projectFilter.conditions
            });
          }}
        />
        <LexiconTable searchParams={searchParams} />
      </div>
    </>
  );
}
